// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1319":"62937355","1803":"62937355","5340":"62937355","5823":"62937355"}[chunkId] + ".chunk.css";
};